import {
  selectAuthFlowHeaderTitle,
  selectAuthFlowLeadText,
} from "@/lib/storage/auth-slice"
import { useAppSelector } from "@/lib/storage/hooks"
import { BotAvatar } from "@/components/ui/avatar"

/** The Mindtrip avatar over the step's centered title and lead text. */
export function AuthFlowHeaders({
  title,
}: {
  /** Replaces the step's title, for steps the auth flow state doesn't name. */
  title?: string
}) {
  const headerText = useAppSelector(selectAuthFlowHeaderTitle)
  const leadText = useAppSelector(selectAuthFlowLeadText)

  return (
    <div className="mb-3 flex flex-col items-center gap-4 text-center">
      <BotAvatar size="md" />
      <h2 className="font-circular text-3xl">{title ?? headerText}</h2>
      {leadText && <p className="leading-snug text-pretty">{leadText}</p>}
    </div>
  )
}
